module.exports = __webpack_public_path__ + "static/media/location.47d075e7.svg";